<template>
  <div class="col">
    <div class="row">
      <h1>Administration</h1>
    </div>
    <div class="row">
      <div class="col">
        <custom-button @click.native="goToCoins">
          Pièces
        </custom-button>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomButton from '../micro-components/custom-button';
  export default {
    name: 'AdminHome',
    components: { CustomButton },
    methods: {
      goToCoins() {
        this.$router.push({ name: 'admin-coins' });
      }
    }
  };
</script>

<style scoped>

</style>
